export interface NoticeDayBucket {
  date: string;
  count: number;
}

/**
 * Buckets notices by calendar day for the last `days` days, oldest first
 * (today last) — matching a left-to-right "trending up to today" chart.
 * `now` is injectable for tests; defaults to the real clock.
 */
export function bucketNoticesByLastNDays<T extends { createdAt: string }>(
  notices: T[],
  days: number,
  now: Date = new Date()
): NoticeDayBucket[] {
  const startDate = new Date(now);
  startDate.setDate(startDate.getDate() - (days - 1));

  const result: NoticeDayBucket[] = [];
  for (let i = 0; i < days; i++) {
    const date = new Date(startDate);
    date.setDate(date.getDate() + i);
    const dateStr = date.toLocaleDateString("en-US", { weekday: "short" });

    const dayStart = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate()
    );
    const dayEnd = new Date(dayStart.getTime() + 24 * 60 * 60 * 1000);

    const count = notices.filter((notice) => {
      const noticeDate = new Date(notice.createdAt);
      return noticeDate >= dayStart && noticeDate < dayEnd;
    }).length;

    result.push({ date: dateStr, count });
  }

  return result;
}
